import { Card, CardHeader, CardContent } from './core/Card';
import { Smartphone } from 'lucide-react';
import { QRCodeSVG } from "qrcode.react";

export function AppsView() {
  return (
    <div className="space-y-6">
      <Card>
      <CardContent className="space-y-6 p-6">
        {/* Header */}
          <div className="flex items-center gap-3 pb-4 border-b border-[#e9e9e9]">
            <div className="size-10 rounded-[10px] bg-[#0084c7]/10 flex items-center justify-center">
              <Smartphone className="size-5 text-[#0084c7]" />
            </div>
            <div>
              <h3 className="text-[18px] font-medium text-[#1c1c1c]">
                Mobile Apps
              </h3>
              <p className="text-[#6b6b6b] text-[14px]">
                Laden Sie unsere App für iOS und Android herunter
              </p>
            </div>
          </div>

        {/* Info Section */}
        <Card className="mt-6">
          <CardContent>
            <div className="flex flex-col md:flex-row md:items-start gap-4">

              <div className="size-12 bg-[#0084c7]/10 rounded-full flex items-center justify-center shrink-0">
                <Smartphone className="size-6 text-[#0084c7]" />
              </div>

              <div className="flex-1">
                <h3 className="text-[#1c1c1c] text-[18px] font-medium mb-2">
                  Zeiterfassung unterwegs
                </h3>

                <p className="text-[#6b6b6b] text-[14px] leading-relaxed">
                  Mit unserer mobilen App können Sie Ihre Arbeitszeiten überall erfassen,
                  Anträge einreichen und Ihre Auswertungen einsehen. Verfügbar für iOS und Android.
                </p>

                <ul className="mt-4 space-y-2">
                  <li className="flex items-start gap-2 text-[#6b6b6b] text-[14px]">
                    <div className="size-1.5 mt-2 bg-[#0084c7] rounded-full shrink-0" />
                    Schnelle Zeiterfassung mit einem Klick
                  </li>

                  <li className="flex items-start gap-2 text-[#6b6b6b] text-[14px]">
                    <div className="size-1.5 mt-2 bg-[#0084c7] rounded-full shrink-0" />
                    Urlaubsanträge und Überstundenanträge mobil einreichen
                  </li>

                  <li className="flex items-start gap-2 text-[#6b6b6b] text-[14px]">
                    <div className="size-1.5 mt-2 bg-[#0084c7] rounded-full shrink-0" />
                    Synchronisierung mit Ihrem Desktop-Account
                  </li>
                </ul>
              </div>

            </div>
          </CardContent>
        </Card>
        {/* App Cards */}
        <div className="grid grid-cols-1 mb-4 md:grid-cols-2 gap-6">
          {/* iOS App Card */}
          <Card>
            <CardHeader
              title="iOS App"
              subtitle="Verfügbar im App Store"
              borderBottom
            />
            <CardContent>
              <div className="flex flex-col items-center py-8">
                {/* App Store Logo */}
                <div className="mb-6">
                  <a
                    href="https://apps.apple.com/us/app/enttro/id6759671896"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mb-6 inline-block"
                  >
                    <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="120" height="40" rx="5" fill="black"/>
                      <text x="60" y="13" fontFamily="Arial, sans-serif" fontSize="8" fill="white" textAnchor="middle">
                        GET IT ON
                      </text>
                      <text x="60" y="28" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fill="white" textAnchor="middle">
                        App Store
                      </text>
                    </svg>
                  </a>
                </div>

                {/* QR Code for App Store */}
                <div className="bg-white p-4 rounded-[12px] border-2 border-[#e9e9e9] mb-4">
                  <QRCodeSVG
                    value="https://apps.apple.com/us/app/enttro/id6759671896"
                    size={200}
                    bgColor="#ffffff"
                    fgColor="#111111"
                    level="Q"
                    includeMargin
                  />
                </div>

                <p className="text-[#6b6b6b] text-[14px] text-center">
                  QR-Code scannen, um die App im App Store zu öffnen
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Android App Card */}
          <Card>
            <CardHeader
              title="Android App"
              subtitle="Verfügbar bei Google Play"
              borderBottom
            />
            <CardContent>
              <div className="flex flex-col items-center py-8">
                {/* Google Play Logo */}
                <div className="mb-6">
                  <a
                    href="https://play.google.com/store/apps/details?id=de.enttro&hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mb-6 inline-block"
                  >
                    <svg width="135" height="40" viewBox="0 0 135 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="135" height="40" rx="5" fill="black"/>
                      <text x="67.5" y="13" fontFamily="Arial, sans-serif" fontSize="8" fill="white" textAnchor="middle">
                        GET IT ON
                      </text>
                      <text x="67.5" y="28" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fill="white" textAnchor="middle">
                        Google Play
                      </text>
                    </svg>
                  </a>
                </div>

                {/* QR Code for Google Play */}
                <div className="bg-white p-4 rounded-[12px] border-2 border-[#e9e9e9] mb-4">
                  <QRCodeSVG
                    value="https://play.google.com/store/apps/details?id=de.enttro&hl=en"
                    size={200}
                    bgColor="#ffffff"
                    fgColor="#111111"
                    level="Q"
                    includeMargin
                  />
                </div>

                <p className="text-[#6b6b6b] text-[14px] text-center">
                  QR-Code scannen, um die App bei Google Play zu öffnen
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </CardContent>
    </Card>  
    </div>
  );
}
